/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Navigation2 = [
  "svg",
  defaultAttributes,
  [["polygon", { points: "12 2 19 21 12 17 5 21 12 2" }]]
];

export { Navigation2 as default };
//# sourceMappingURL=navigation-2.js.map
